import React from "react";
import { useSelector } from "react-redux";
import selectors from "selectors";
import NewOrderForm from "./index";
import OrderFormProvider from "./provider";
import useTranslate from "hooks/use-translate-language";
import useDocumentTitle from "hooks/use-document-title";
import { Page } from "components/ui";
import browserHistory from "browser-history";
import BreadCrumbs from "components/ui_new/breadcrumbs";

const NewAppOrderFormContainer = () => {
  const token = useSelector(selectors.getAuthenticationToken);
  const patientId = useSelector(selectors.getUserId);
  const translate = useTranslate();
  
  useDocumentTitle(translate("orderSupplies"), "Wellsky");

  return (
    <Page.Container >
      <Page.Header
        title={translate("orderSupplies")}
        goBack="/"
        closeText="areYouSureYouWantToCancel"
      />
      <BreadCrumbs
        childLabel="orderSupplies"
        parentLink="orders"
        parentLinkLabel="orders"
        title="chooseSupplies"
      />
      <Page.Content>
        <OrderFormProvider
          patientId={patientId}
          token={token}
          origin={"Patient Portal"}
          handleCreateOrderSuccess={() => {
            browserHistory.push("/");
          }}
        >
          <NewOrderForm />
        </OrderFormProvider>
      </Page.Content>
    </Page.Container>
  );
};

export default NewAppOrderFormContainer;
